import { useMedia } from '@dx-system/react-use'

/**
 * hover特性を持っている環境かを判定するhook
 * @returns
 */
export const useHasHover = (): boolean => {
  return useMedia('(hover: hover) and (pointer: fine)')
}
